import { Component, forwardRef, signal, input, computed } from "@angular/core"
import { columns } from "./common"
import { LogTable } from "./log-table"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { COMMON_IMPORTS } from "@app/common-imports"

@Component({
	selector: "[row]",
	imports: [COMMON_IMPORTS, forwardRef(() => LogTable), ModalWrapComponent],
	host: { "[class]": "cls()" },
	template: `
		@for (field of fields; track field) {
			@if (field == "name" && !user_id()) {
				<td
					class="pointer"
					(click)="isOpen.set(true)"
				>
					{{ row()[field] }}
				</td>
			} @else {
				<td>{{ row()[field] }}</td>
			}
		}
		@if (isOpen()) {
			<app-modal-wrap
				(onClose)="isOpen.set(false)"
				title="activity"
			>
				<app-activity-log-table
					(onClose)="isOpen.set(false)"
					[user_id]="row().user_id"
				/>
			</app-modal-wrap>
		}
	`,
})
export class Row {
	isOpen = signal(false)
	row = input.required<any>()
	user_id = input.required()

	cls = computed(() => ({
		"highlight-row": this.row().highlight_row,
		"highlight-row2": this.row().highlight_row2,
	}))

	fields = columns
}
